import { render, staticRenderFns } from "./IntroNotices.vue?vue&type=template&id=7cee6771"
import script from "./IntroNotices.vue?vue&type=script&lang=js"
export * from "./IntroNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports